module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s01-1-a56ed22e8b833e6baba9ff2df65ff14c.png";